<template>
  <form-group>
    <form-label :label="label" :required="required">
      <slot name="label"></slot>
    </form-label>
    <div :class="{ boxed, 'is-valid': state === true, 'is-invalid': state === false }">
      <slot></slot>
    </div>
    <form-feedback v-if="!!validation" :validation="validation">
      <template slot="required">
        <slot name="required"></slot>
      </template>
      <template slot="maxLength"><slot name="maxLength"></slot></template>
      <template slot="invalid"><slot name="invalid"></slot></template>
    </form-feedback>
  </form-group>
</template>

<script>
  import FormGroup from '@/Atoms/FormGroup';
  import FormLabel from '@/Atoms/FormLabel';
  import FormFeedback from '@/Atoms/FormFeedback';
  import { formValidationMixin } from '../validators';

  export default {
    name: 'FormElement',
    mixins: [formValidationMixin],

    components: {
      FormFeedback,
      FormLabel,
      FormGroup,
    },

    props: {
      label: String,
      validation: Object,
      boxed: Boolean,
      required: Boolean,
    },

    computed: {
      state() {
        return this.validation ? this.inputState(this.validation) : null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../sass/config/variables';

  ::v-deep {
    .custom-checkbox {
      &.custom-control {
        padding-left: 0.8rem;
      }
    }
    .required {
      & > label {
        justify-content: flex-start !important;
        :after {
          margin-left: 0.25rem;
        }
      }
    }
  }
</style>
